import { queryOptions } from "@tanstack/react-query";
import { getFolders, listAllGrundartikel } from "@/api/stock";

// Katalog und Suche im Grundartikel teilen sich diese Queries (gleicher Schluessel = ein Cache).
// queryFn als Pfeil: der Zugriff auf den Export erfolgt erst beim Laden.
export const katalogOrdnerQuery = queryOptions({
  queryKey: ["catalog-folders"],
  queryFn: () => getFolders(),
  staleTime: 5 * 60_000,
});

export const katalogArtikelQuery = queryOptions({
  queryKey: ["catalog-grundartikel"],
  queryFn: () => listAllGrundartikel(),
  staleTime: 60_000,
});
